









































import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '@/store';
import { UserConfModule } from '@/store/modules/userConf';
import { ThemeConfModule } from '@/store/modules/theme';
import { getModule } from 'vuex-module-decorators';
import ThemeConf from '@/types/ThemeConf';

const UserConfState = getModule(UserConfModule, store);
const ThemeStore = getModule(ThemeConfModule, store);

@Component
export default class TrainingOption extends Vue {
  //props server as initial value
  @Prop() audio!: boolean;
  audioValueOn: string = 'On';
  audioValueOff: string = 'Off';

  staticButtonValueOn: string = 'On';
  staticButtonValueOff: string = 'Off';

  designModeValueLight: string = 'Light';
  designModeValueDark: string = 'Dark';

  get theme(): ThemeConf | null {
    return ThemeStore.getTheme;
  }

  get audioValue() {
    return UserConfState.getAudio;
  }

  get lightMode() {
    return UserConfState.getLightMode;
  }
 
  get staticButtonValue() {
    return UserConfState.getStaticButton;
  }
 

  get allowThemeMode() {
    if (this.theme)
      return this.theme.dark_mode_allowed && this.theme.light_mode_allowed;
    return true;
  }
  mounted() {
    store.watch(
      () => ThemeStore.getTheme,
      () => {
        this.updateLightDarkMode();
      }
    );
  }
  updateLightDarkMode() {
    if (this.theme && this.theme.default_mode)
      UserConfState.setLightMode(this.theme.default_mode == 'light');
  }
  getLightModeText(reverse: boolean = false): string {
    let lightMode = reverse ? !this.lightMode : this.lightMode;
    return lightMode ? this.designModeValueDark : this.designModeValueLight;
  }

  getAudioText(reverse: boolean = false): string {
    let audioValue = reverse ? !this.audioValue : this.audioValue;
    return audioValue ? this.audioValueOn : this.audioValueOff;
  }

  getStaticButtonValue(reverse: boolean = false):string {
    let staticButtonValue = reverse ? !this.staticButtonValue : this.staticButtonValue;
    return staticButtonValue ? this.staticButtonValueOn : this.staticButtonValueOff;
  }

  getStaticButtonText(reverse: boolean = false):string {
    return `Static button ${this.getStaticButtonValue(reverse)}`;
  }

  changeLightMode() {
    UserConfState.changeLightMode();
  }

  changeAudioValue() {
    UserConfState.changeAudio();
  }

  changeStaticButton(){
    UserConfState.changeStaticButton();
  }
}
